import { groupBy, map } from "lodash";
import React from "react";
import titleize from "../../titleize";
import FilterChip from "../../../components/pages/SearchPage/components/FilterChip";
import { Small } from "../../../components/elements/v2/Typography/Typography";
import Box from "../../../components/elements/v2/Box/Box";
import { useRefinementList } from "react-instantsearch";
import FilterSection from "../../../components/pages/SearchPage/components/FilterSection";

type Props = {
  label: string;
  attribute: string;
};
export default function ChipGroupFilter({ label, attribute }: Props) {
  const { items, refine, canRefine } = useRefinementList({ attribute, limit: 100 });
  const selectedValues = items.filter((item) => item.isRefined).map((item) => item.value);
  const groupedOptions = groupBy(items, (item) => titleize(item.label.split("|")[0]));
  const hasSelectedItems = selectedValues.length > 0;

  function handleToggle(item) {
    refine(item.value);
  }

  return (
    <FilterSection label={label} canRefine={canRefine} hasSelectedItems={hasSelectedItems}>
      {map(groupedOptions, (options, key) => (
        <div key={key} className="t-searchFilterGroup" style={{ marginBottom: "24px" }}>
          <Box mb={1}>
            <Small>{key}</Small>
          </Box>
          {map(options, (option) => (
            <FilterChip
              key={option.value}
              label={option.label.split("|").slice(-1)[0]}
              onClick={() => handleToggle(option)}
              $selected={selectedValues.includes(option.value)}
              size="small"
            />
          ))}
        </div>
      ))}
    </FilterSection>
  );
}
